var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-xs"},[_vm._v("Создать рекламацию")]),_c('div',{staticClass:"box"},[_c('ReclamationExternalEditForm',{attrs:{"is-create":""},on:{"cancel":_vm.goToReclamationListPage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }